(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/picasso/assets/javascripts/picasso-image-multi.js') >= 0) return;  svs.modules.push('/components/numbergames/picasso/assets/javascripts/picasso-image-multi.js');

'use strict';

const {
  picassoInstance,
  imagesFitWrapper,
  imagesLazyLoading,
  preferredWidths,
  imagesDescription,
  availableFormats,
  getAspectRatio,
  getMultiBreakPoint
} = svs.numbergames.picasso.setup;


const getMultiImageOptions = (filenameDesktop, imageTypeDesktop, filenameMobile, imageTypeMobile, title, altText, fitWrapper, loadingLazy) => {
  var _imagesDescription$im, _imagesDescription$im2, _getAspectRatio, _getAspectRatio2;
  const pathRegex = new RegExp(/^.*[\\/]/);
  filenameDesktop = filenameDesktop.replace(pathRegex, '');
  filenameMobile = filenameMobile.replace(pathRegex, '');
  const urlDesktop = "/".concat(picassoInstance[imageTypeDesktop], "/{width}/{extension}/").concat(filenameDesktop);
  const urlMobile = "/".concat(picassoInstance[imageTypeMobile], "/{width}/{extension}/").concat(filenameMobile);
  const noscriptUrl = "/".concat(picassoInstance[imageTypeDesktop], "/").concat(preferredWidths[imageTypeDesktop][0], "/").concat(filenameDesktop.split('.')[1], "/").concat(filenameDesktop);
  return {
    altText: altText || ((_imagesDescription$im = imagesDescription[imageTypeDesktop]) === null || _imagesDescription$im === void 0 ? void 0 : _imagesDescription$im.altText),
    title: title || ((_imagesDescription$im2 = imagesDescription[imageTypeDesktop]) === null || _imagesDescription$im2 === void 0 ? void 0 : _imagesDescription$im2.title),
    fitWrapper: fitWrapper || imagesFitWrapper[imageTypeDesktop],
    loadingLazy: loadingLazy || imagesLazyLoading[imageTypeDesktop],
    originalImage: false,
    url: urlDesktop,
    noscriptUrl,
    availableWidths: preferredWidths[imageTypeDesktop],
    images: {
      0: {
        dominantColor: 'transparent',
        media: "(min-width: ".concat(getMultiBreakPoint(imageTypeDesktop), ")"),
        sizes: "(min-width: ".concat(getMultiBreakPoint(imageTypeDesktop), ") 100vw)"),
        url: urlDesktop,
        availableWidths: preferredWidths[imageTypeDesktop],
        aspectRatio: {
          width: (_getAspectRatio = getAspectRatio(imageTypeDesktop)) === null || _getAspectRatio === void 0 ? void 0 : _getAspectRatio.width,
          height: (_getAspectRatio2 = getAspectRatio(imageTypeDesktop)) === null || _getAspectRatio2 === void 0 ? void 0 : _getAspectRatio2.height
        },
        availableFormats
      },
      1: {
        media: "(max-width: ".concat(getMultiBreakPoint(imageTypeMobile), ")"),
        sizes: "(max-width: ".concat(getMultiBreakPoint(imageTypeMobile), ") 100vw)"),
        dominantColor: 'transparent',
        url: urlMobile,
        availableWidths: preferredWidths[imageTypeMobile],
        aspectRatio: {
          width: getAspectRatio(imageTypeMobile).width,
          height: getAspectRatio(imageTypeMobile).height
        },
        availableFormats
      }
    }
  };
};
const exported = {
  getMultiImageOptions
};
if (svs.isServer) {
  module.exports = exported;
} else {
  svs.numbergames.picasso.image_multi = exported;
}

 })(window);